<template>
  <div class="compensated-container">
    <hr />
    <h3>Recent Compensation</h3>
    <h2 v-if="compensatedData.id">
      Id: <strong>{{ compensatedData.id }}</strong>
    </h2>
    <p>
      Title: <strong>{{ compensatedData.title }}</strong>
    </p>
    <p>
      Compensated at:
      <strong>{{ compensatedData.compensated_at.slice(0, 10) }}</strong>
    </p>
    <p>
      Proof URL: <strong>{{ compensatedData.proof_url }}</strong>
    </p>
    <p>
      Description: <strong>{{ compensatedData.description }}</strong>
    </p>
    <p>
      Total Compensated CO2 kg:
      <strong>{{ compensatedData.total_compensated_co2_kg }}</strong>
    </p>
    <p v-if="compensatedData.is_open">
      Is open: <strong>{{ compensatedData.is_open }}</strong>
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  name: "CompensatedData",
  data: function () {
    return {};
  },
  props: {
    compensatedData: {
      type: Object,
    },
  },
};
</script>
<style lang="css">
.compensated-container {
  max-width: 80vw;
  margin: 0 auto;
}
@media (min-width: 768px) {
  .compensated-container {
    width: 40rem;
  }
}
</style>
